import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../../../../baseClasses/BaseComponent';
import PhotoGridCard from './PhotoGridCard';
import csPhotoDefault from '../../../../../../assets/images/photo-jpg-placeholder.svg';
import PhotoCarousel from '../../../../../PhotoCarousel';
import PhotoPermissionsUtil from '../../../../../../helpers/permissions/PhotoPermissionsUtil';
import dataModel from '../../../../../../models/DataModel';
import CompletionStepPermissionsUtil from '../../../../../../helpers/permissions/CompletionStepPermissionsUtil';

import './TaskCompletionStepPhotoGrid.scss';

// TODO: this component is duplicated - collapse into 1

/**
 * This component is used in the tasks container for web&mobile 
 * completion step uploads when at least one photo already exists under the step
 */
export class TaskCompletionStepPhotoGrid extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { commentText: '' };

    this.canOverrideUpload = this.canOverrideUpload.bind(this);
    this.closePhotoPopup = this.closePhotoPopup.bind(this);
  }

  componentDidMount() {
    this.sortAttachments(this.props.attachments);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.attachments != this.props.attachments) {
      this.sortAttachments(this.props.attachments);
    }
  }

  canOverrideUpload() {
    const { task, completionStep, userStepPermissions } = this.props;
    return CompletionStepPermissionsUtil.canOverrideUpload(task, completionStep, userStepPermissions);
  }

  sortAttachments(attachments) {
    let newAttachments = [];
    if (attachments) {
      newAttachments = attachments.map(a => {
        return Object.assign({}, a);
      });
    }
    this.setState({
      attachments: newAttachments,
    });
  }

  get attachments() {
    //return (this.state.attachments || this.props.attachments)
    return this.props.attachments;
  }

  filterAttachments(attachments) {
    const hasPositiveId = (obj) => obj.id > 0;

    const groupedAttachments = {};
    attachments.forEach(attachment => {
      if (!groupedAttachments[attachment.name]) {
        groupedAttachments[attachment.name] = [];
      }
      groupedAttachments[attachment.name].push(attachment);
    });

    const filteredAttachments = [];
    Object.values(groupedAttachments).forEach(group => {
      const positiveIdObject = group.find(hasPositiveId);
      const negativeIdObject = group.find(obj => !hasPositiveId(obj));

      if (positiveIdObject) {
        filteredAttachments.push(positiveIdObject);
      } else if (negativeIdObject) {
        filteredAttachments.push(negativeIdObject);
      }
    });
    return filteredAttachments;
  }

  handlePhotoSelection(attachment) {
    this.setState({
      displaySelectedPhoto: true,
      selectedPhoto: attachment,
    });
    if (this.props.handlePhotoSelection) {
      this.props.handlePhotoSelection(true);
    }
  }

  handleDeletePhoto(attachment) {
    this.setState({ selectedPhoto: attachment });
  }

  closePhotoPopup() {
    this.setState({ displaySelectedPhoto: false });
    if (this.props.handlePhotoSelection) {
      this.props.handlePhotoSelection(false);
    }
  }

  createPhotoList() {
    const { uploadsInProgress } = this.props;
    let attachments = this.attachments;

    // Filter attachments
    if (attachments.length > 1) {
      attachments = this.filterAttachments(attachments);
    }

    if (uploadsInProgress == 1 && !attachments.length) {
      return (
        <div className="single-photo">
          <PhotoGridCard 
            key={'upload-image-' + Math.random()} 
            uploadImage={true} 
            medium={this.props.medium} 
            single={true}
            noBorder={this.props.maxPhotos} 
          />
        </div>
      );
    }
    //single photo already uploaded
    else if (attachments.length == 1 && !uploadsInProgress) {
      return (
        <div className="single-photo">
          <PhotoGridCard
            key={attachments[0].id}
            attachment={attachments[0]}
            handlePhotoSelection={this.handlePhotoSelection}
            hideName={this.props.withAcceptReject}
            single={true} medium={this.props.medium}
            noBorder={this.props.maxPhotos}
          />
        </div>
      );
    } 
    //upload attachments already there
    else if (attachments.length >= 1) {
      let photoRows = [];
      let photoArray = [];
      let count = 0;
    
      //for each
      attachments.forEach(attachment => {
        if (attachment.upload) {
          photoArray.push(
            <div className="photo" key={'photo-div-' + attachment.id}>
              <PhotoGridCard
                key={attachment.id}
                attachment={attachment}
                hideName={true}
                handlePhotoSelection={this.handlePhotoSelection} medium={this.props.medium}
                noBorder={this.props.maxPhotos}
              />
            </div>
          );
        }
      });

      if (uploadsInProgress) {
        for (let i = 0; i < uploadsInProgress; i++) {
          photoArray.push(
            <div className="photo" key={'photo-div-loading-' + i}>
              <PhotoGridCard
                key={'upload-image-' + count}
                uploadImage={true}
                hideName={true} medium={this.props.medium}
                noBorder={this.props.maxPhotos}
              />
            </div>
          );
        }
      }

      for (let i = 0; i < photoArray.length; i += 4, count++) {
        photoRows.push(
          <div className="photo-row" key={count + 1}>
            { photoArray.slice(i, i + 4) }
          </div>
        );
      }

      return photoRows;
    }
    else {
      return [];
    }
  }

  handleSetAttachmentToDefaultImage(newAttachment) {
    this.attachments.forEach(attachment => {
      if (attachment.id == newAttachment.id) {
        attachment.upload = csPhotoDefault;
      }
    });
  }

  render() {
    const { completionStep, task } = this.props;
    if (!completionStep) {
      return null;
    }
    let display, webPopup;
    
    const displayPhotoList = this.createPhotoList();
    let height = 'auto';
    if (this.attachments.length == 1) {
      height = 220;
    } else if (this.attachments.length > 1) {
      height = Math.ceil(this.attachments.length / 4) * 110;
    }

    display = <div className={'task-completion-step-photo-grid ' + (this.props.withAcceptReject ? 'accept-reject' : '') + (this.props.maxPhotos ? ' transparent' : '')} style={{ height: height }}>
        <div className={'photo-list ' + (this.props.withAcceptReject ? 'accept-reject' : '') + (this.props.maxPhotos ? ' transparent' : '')}>
          <div className="photos">
            {displayPhotoList}
          </div>
        </div>
      </div>;

    if (this.state.displaySelectedPhoto) {
      const canUserEditPhoto = PhotoPermissionsUtil.canUserEditPhoto(this.props.userStepPermissions, completionStep, task);
      webPopup = (
        <div className="carousel-container">
          <PhotoCarousel
            attachments={completionStep.attachments}
            completionStep={completionStep}
            initialAttachmentId={this.state.selectedPhoto && this.state.selectedPhoto.id}
            handleClose={this.closePhotoPopup}
            handleDelete={this.handleDeletePhoto}
            hasDelete={canUserEditPhoto}
            hasRename={canUserEditPhoto}
          />
        </div>
      );
    }
    return (
      <div className="grid-container">
        {webPopup}
        {display}
      </div>
    );
  }
  
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    inProgress: state.main.inProgress,
    permissions: state.new_users ? state.new_users.permissions : null,
    currentUser: state.new_users ? state.new_users.currentUser : null,
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null,
  };
};

export default connect(mapStateToProps)(
  TaskCompletionStepPhotoGrid
);



// WEBPACK FOOTER //
// ./src/components/TaskCRUD/TaskCompletionStepsContainer/TaskCompletionSteps/PhotoUpload/TaskCompletionStepPhotoGrid/index.js